<template>
  <v-navigation-drawer
    v-model="drawer"
    width="950"
    app
    temporary
    right
    class="wost-drawer"
  >
    <div
      class="navigation-head"
      style="display:flex; justify-content:space-between;"
    >
      <span>{{ titleForm }}</span>
      <!-- <v-col cols="2" style="padding:0;">
        <v-btn
          dark
          color="success"
          block
          height="40"
          @click="changeGeneratePdf"
        >
          GEnerarPDF
        </v-btn>
      </v-col> -->
    </div>

    <div class="pl-3 pt-3 pr-3" style="height: 80vh;">
      <template>
        <v-row class="pl-3 pr-3 pb-2">
          <!-- <v-col cols="12">
            <v-text-field
                ref="name" 
                v-model="informarForm.name" 
                label="Nombre" 
                outlined 
                :rules="[() => !!informarForm.name || 'Es necesario ingresar un nombre']"
                hide-details="auto"
                required
            ></v-text-field>
          </v-col> -->
          <v-file-input
            accept="image/png, image/jpeg, image/bmp"
            placeholder="Imagen de Resultado"
            prepend-icon="mdi-camera"
            label="Avatar"
            type="file"
            v-model="informarForm.image"
          ></v-file-input>
        </v-row>
        <v-divider></v-divider>

        <div
          class=""
          style="display: flex; width: 100%; padding: 10px 5px 0 10px; "
        >
          <div v-for="(item, indice) of data" :key="indice">
            <label
              for=""
              v-if="item.select"
              class="btn btn-active"
              @click="changeCabecera(item)"
              style="padding:0 10px"
            >
              {{ item.specialized_name }}
            </label>
            <label
              for=""
              v-if="!item.select"
              class="btn"
              @click="changeCabecera(item)"
              style="padding:0 10px"
            >
              {{ item.specialized_name }}
            </label>
          </div>
        </div>

        <div v-for="(item, indice) of data" :key="indice">
          <div
            id="body"
            v-if="item.select"
            style="display:flex; width:100%;  padding-top:5px; height: 34rem; overflow: auto; "
          >
            <div
              v-for="(itemDetalle, indiceDetalle) of item.detalle"
              :key="indiceDetalle"
              style="width:100%; "
            >
              <div
                v-if="itemDetalle.iscompound == null"
                style="display:flex; width:100%;"
              >
                <!-- para cuando no es compuesto -->
                <v-divider></v-divider>
                <!-- cuando es dinamico -->
                <div
                  style=" width:100%; padding-bottom:2px; padding-left:25px; padding-top:5px;"
                  v-if="itemDetalle.dinamic"
                >
                  <div style="display: flex;">
                    <v-checkbox
                      v-model="itemDetalle.infoMachine"
                      :value="itemDetalle.infoMachine"
                      hide-details
                      style="display:flex; margin-top:0px!important; padding-top:0px!important; margin-bottom:0px; "
                    ></v-checkbox>
                    <label for="">Dispositivos info</label>
                  </div>

                  <div v-if="itemDetalle.infoMachine" class="div-table-editor">
                    <vue-editor
                      id="responsibilityEdit"
                      class="table-editor"
                      v-model="itemDetalle.infoMachineInput"
                      placeholder="----"
                    ></vue-editor>
                  </div>

                  <div style="display: flex;">
                    <div
                      style="display:flex; flex-direction: column;width:70%;"
                    >
                      <div style="display:flex">
                        <v-checkbox
                          v-model="itemDetalle.check"
                          :value="itemDetalle.check"
                          style="display:flex; margin-top:0px!important; padding-top:0px!important; "
                          hide-details
                        ></v-checkbox>
                        <label
                          for=""
                          style="display:flex;color:black; font-weight:900;"
                          >{{ itemDetalle.name }}</label
                        >
                      </div>
                      <div style="display:flex;">
                        <label for="" style="color:black; font-weight:600;"
                          >Unidad M:
                        </label>
                        <label for="">{{ itemDetalle.unit_name }}</label>
                      </div>
                      <div style="display:flex;">
                        <label for="" style="color:black; font-weight:600;"
                          >Rango referencial:
                        </label>
                        <div
                          v-html="itemDetalle.rank"
                          style="margin-bottom:0px !important; font-size:13px; padding-left:5px;"
                        ></div>
                        <!-- <div v-html="itemDetalle.rank"></div> -->
                        <!-- <label for="">{{itemDetalle.rank}}</label> -->
                      </div>
                    </div>
                    <div style="width:30%;">
                      <div style="width: 100%">
                        <v-text-field
                          ref="result"
                          v-model="itemDetalle.result"
                          v-on:keyup="
                            handleKeyUpResultado($event, item, itemDetalle)
                          "
                          label="Resultado"
                          outlined
                          hide-details="auto"
                          required
                        >
                        </v-text-field>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="itemDetalle.complementaryResult"
                    class="div-table-editor"
                  >
                    <vue-editor
                      id="responsibilityEdit"
                      class="table-editor"
                      v-model="itemDetalle.complementaryResultInput"
                      placeholder="Informacion Adicional"
                    ></vue-editor>
                  </div>

                  <div style="display: flex;">
                    <v-checkbox
                      v-model="itemDetalle.commentResult"
                      :value="itemDetalle.commentResult"
                      hide-details
                      style="display:flex; margin-top:0px!important; padding-top:0px!important; margin-bottom:0px; "
                    ></v-checkbox>
                    <label for="">Comentario</label>
                  </div>

                  <div
                    v-if="itemDetalle.commentResult"
                    class="div-table-editor"
                  >
                    <vue-editor
                      id="responsibilityEdit"
                      class="table-editor"
                      v-model="itemDetalle.commentInput"
                      placeholder="----"
                    ></vue-editor>
                  </div>
                </div>
                <!-- cuando no es dinamico -->
                <div
                  v-else
                  style=" width:100%; padding-bottom:2px; padding-left:25px; padding-top:5px;"
                >
                  <div style="display: flex;">
                    <v-checkbox
                      v-model="itemDetalle.infoMachine"
                      :value="itemDetalle.infoMachine"
                      hide-details
                      style="display:flex; margin-top:0px!important; padding-top:0px!important; margin-bottom:0px; "
                    ></v-checkbox>
                    <label for="">Dispositivos info</label>
                  </div>

                  <div v-if="itemDetalle.infoMachine" class="div-table-editor">
                    <vue-editor
                      id="responsibilityEdit"
                      class="table-editor"
                      v-model="itemDetalle.infoMachineInput"
                      placeholder="----"
                    ></vue-editor>
                  </div>

                  <div style="display: flex;">
                    <div
                      style="display:flex; flex-direction: column; width:70%;"
                    >
                      <div style="display:flex">
                        <v-checkbox
                          v-model="itemDetalle.check"
                          :value="itemDetalle.check"
                          style="display:flex; margin-top:0px!important; padding-top:0px!important; "
                          hide-details
                        ></v-checkbox>
                        <label
                          for=""
                          style="display:flex;color:black; font-weight:900;"
                          >{{ itemDetalle.name }}</label
                        >
                      </div>
                      <div style="display:flex;">
                        <label for="" style="color:black; font-weight:600;"
                          >Unidad M:
                        </label>
                        <label for="">{{ itemDetalle.unit_name }}</label>
                      </div>
                      <div style="display:flex; ">
                        <label for="" style="color:black; font-weight:600;"
                          >Rango referencial:
                        </label>
                        <div
                          v-html="itemDetalle.rank"
                          style="margin-bottom:0px !important; font-size:13px; padding-left:5px;"
                        ></div>
                        <!-- <label for="">{{itemDetalle.rank}}</label> -->
                      </div>
                    </div>
                    <div style="width:30%;">
                      <div style="width: 100%">
                        <v-text-field
                          ref="result"
                          v-model="itemDetalle.result"
                          v-on:keyup="
                            handleKeyUpResultado($event, item, itemDetalle)
                          "
                          label="Resultado"
                          outlined
                          hide-details="auto"
                          required
                        >
                        </v-text-field>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="itemDetalle.complementaryResult"
                    class="div-table-editor"
                  >
                    <vue-editor
                      id="responsibilityEdit"
                      class="table-editor"
                      v-model="itemDetalle.complementaryResultInput"
                      placeholder="Informacion Adicional"
                    ></vue-editor>
                  </div>
                  <div style="display: flex;">
                    <v-checkbox
                      v-model="itemDetalle.commentResult"
                      :value="itemDetalle.commentResult"
                      hide-details
                      style="display:flex; margin-top:0px!important; padding-top:0px!important; margin-bottom:0px; "
                    ></v-checkbox>
                    <label for="">Comentario</label>
                  </div>

                  <div
                    v-if="itemDetalle.commentResult"
                    class="div-table-editor"
                  >
                    <vue-editor
                      id="responsibilityEdit"
                      class="table-editor"
                      v-model="itemDetalle.commentInput"
                      placeholder="----"
                    ></vue-editor>
                  </div>
                </div>
                <v-divider></v-divider>
              </div>
              <div v-else>
                <!-- para cuando es compuesto -->
                <div
                  id="cabecera-compuesto"
                  style=" display:flex; font-weight:600;color:black;"
                >
                  <v-checkbox
                    v-model="itemDetalle.check"
                    :value="itemDetalle.check"
                    @change="changeCabeceraAnalisisCompuesta(itemDetalle)"
                    hide-details
                    style="display:flex; margin-top:0px!important; padding-top:0px!important; margin-bottom:0px; "
                  ></v-checkbox>
                  {{ itemDetalle.name }}
                </div>
                <div
                  v-for="(itemDetalleDetalle,
                  indiceDetalleDetalle) of itemDetalle.detalle"
                  :key="indiceDetalleDetalle"
                  style="display:flex; flex-direction: column; width:100%;"
                >
                  <v-divider></v-divider>
                  <!-- cuando es dinamico - opcion para seleccionar si se va a mostrar  -->
                  <div v-if="itemDetalleDetalle.dinamic">
                    <div
                      style=" width:100%; padding-bottom:2px; padding-left:25px;  padding-top:5px;"
                    >
                      <div style="display: flex;">
                        <v-checkbox
                          v-model="itemDetalleDetalle.infoMachine"
                          :value="itemDetalleDetalle.infoMachine"
                          hide-details
                          style="display:flex; margin-top:0px!important; padding-top:0px!important; margin-bottom:0px; "
                        ></v-checkbox>
                        <label for="">Dispositivos info</label>
                      </div>

                      <div
                        v-if="itemDetalleDetalle.infoMachine"
                        class="div-table-editor"
                      >
                        <vue-editor
                          id="responsibilityEdit"
                          class="table-editor"
                          v-model="itemDetalleDetalle.infoMachineInput"
                          placeholder="----"
                        ></vue-editor>
                      </div>

                      <div style="display: flex;">
                        <div
                          id="checkbox-name"
                          style="display:flex; flex-direction: column; width:70%;"
                        >
                          <div style="display:flex;">
                            <v-checkbox
                              v-model="itemDetalleDetalle.check"
                              :value="itemDetalleDetalle.check"
                              @change="
                                changeCabeceraDetailAnalisisCompuesta(
                                  itemDetalle,
                                  itemDetalleDetalle
                                )
                              "
                              hide-details
                              style="display:flex; margin-top:0px!important; padding-top:0px!important; margin-bottom:0px; "
                            ></v-checkbox>
                            <label for="" style="color:black; font-weight:900;">
                              {{ itemDetalleDetalle.name }}
                            </label>
                          </div>
                          <div style="padding-bottom:2px;">
                            <label for="" style="color:black; font-weight:600;"
                              >Unidad M:
                            </label>
                            <label for="">{{
                              itemDetalleDetalle.unit_name
                            }}</label>
                          </div>
                          <div style="display:flex;">
                            <label for="" style="color:black; font-weight:600;"
                              >Rango referencial:
                            </label>
                            <div
                              v-html="itemDetalleDetalle.rank"
                              style="margin-bottom:0px !important; font-size:13px; padding-left:5px;"
                            ></div>
                            <!-- <label for="">{{itemDetalleDetalle.rank}}</label> -->
                          </div>
                        </div>
                        <div id="input" style="width:30%; align-self:center;">
                          <div style="width: 100%">
                            <v-text-field
                              ref="result"
                              v-model="itemDetalleDetalle.result"
                              v-on:keyup="
                                handleKeyUpResultadoCompuesto(
                                  $event,
                                  item,
                                  itemDetalle,
                                  itemDetalleDetalle
                                )
                              "
                              label="Resultado"
                              outlined
                              hide-details="auto"
                              required
                            >
                            </v-text-field>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="itemDetalleDetalle.complementaryResult"
                        class="div-table-editor"
                      >
                        <vue-editor
                          id="responsibilityEdit"
                          class="table-editor"
                          v-model="itemDetalleDetalle.complementaryResultInput"
                          placeholder="Informacion Adicional"
                        ></vue-editor>
                      </div>

                      <div style="display: flex;">
                        <v-checkbox
                          v-model="itemDetalleDetalle.commentResult"
                          :value="itemDetalleDetalle.commentResult"
                          hide-details
                          style="display:flex; margin-top:0px!important; padding-top:0px!important; margin-bottom:0px; "
                        ></v-checkbox>
                        <label for="">Comentario</label>
                      </div>

                      <div
                        v-if="itemDetalleDetalle.commentResult"
                        class="div-table-editor"
                      >
                        <vue-editor
                          id="responsibilityEdit"
                          class="table-editor"
                          v-model="itemDetalleDetalle.commentInput"
                          placeholder="----"
                        ></vue-editor>
                      </div>
                    </div>
                  </div>

                  <!-- cuando no es dinamico - no aparece la opcion de seleccionar si se va a mostrar o no  -->
                  <div
                    v-else
                    style="display:flex; width:100%; padding-left:25px;  padding-top:5px;"
                  >
                    <div
                      id="checkbox-name"
                      style="display:flex; flex-direction: column; width:70%;"
                    >
                      <label for="" style="padding-bottom:2px;">
                        {{ itemDetalleDetalle.name }}</label
                      >
                      <div style="display:flex;">
                        <label for="" style="color:black; font-weight:600;"
                          >Unidad M:
                        </label>
                        <label for="">{{ itemDetalleDetalle.unit_name }}</label>
                      </div>
                      <div style="display:flex;">
                        <label for="" style="color:black; font-weight:600;"
                          >Rango referencial:
                        </label>
                        <!-- <label for="">{{itemDetalleDetalle.rank}}</label> -->
                        <div
                          v-html="itemDetalleDetalle.rank"
                          style="margin-bottom:0px !important; font-size:13px; padding-left:5px;"
                        ></div>
                      </div>
                    </div>
                    <div id="input" style="width:30%; align-self:center;">
                      <div style="width: 100%">
                        <v-text-field
                          ref="result"
                          v-model="itemDetalleDetalle.result"
                          v-on:keyup="
                            handleKeyUpResultadoCompuesto(
                              $event,
                              item,
                              itemDetalle,
                              itemDetalleDetalle
                            )
                          "
                          label="Resultado"
                          outlined
                          hide-details="auto"
                          required
                        >
                        </v-text-field>
                      </div>
                    </div>
                    <div
                      v-if="itemDetalleDetalle.complementaryResult"
                      class="div-table-editor"
                    >
                      <vue-editor
                        id="responsibilityEdit"
                        class="table-editor"
                        v-model="itemDetalleDetalle.complementaryResultInput"
                        placeholder="Informacion Adicional"
                      ></vue-editor>
                    </div>
                  </div>

                  <v-divider></v-divider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div class="mt-3 pl-3 pt-3 pr-3 ">
      <template>
        <v-row>
          <v-col cols="6">
            <v-btn block height="40" dark color="red" @click="handleCancel">
              <v-icon class="mr-1" size="16">far fa-times-circle</v-icon>
              Cancelar
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              v-if="action == 'create'"
              dark
              color="success"
              block
              height="40"
              @click="handleStore"
            >
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Guardar
            </v-btn>
            <v-btn
              v-if="action == 'update'"
              dark
              color="success"
              block
              height="40"
              @click="handleUpdate"
            >
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Actualizar
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";
import InformarTools from "../../helpers/InformarTools";
import { jsPDF } from "jspdf";
import JQuery from "jquery";
import html2pdf from "html2pdf.js";
import { VueEditor } from "vue2-editor";

let $ = JQuery;
export default {
  name: "CreateUpdate",
  components: {
    VueEditor,
  },
  data() {
    return {
      drawer: false,
      titleForm: null,
      action: null,
      informarForm: {
        id: null,
        data: [],
        image: null,
        name: null,
        description: null,
      },
      data: [],
    };
  },
  computed: {
    ...mapState("authentication", ["office_id"]),
  },
  methods: {
    ...mapActions("informar", ["store", "update", "generatePdf"]),
    async showForm(title, action, procesamiento = null) {
      await this.clearData();
      this.titleForm = title;
      this.action = action;
      if (procesamiento) {
        this.setProcesamiento(procesamiento);
      }
      this.drawer = !this.drawer;
    },
    clearData() {
      this.titleForm = null;
      this.action = null;
      this.informarForm.id = null;
      this.informarForm.name = null;
      this.informarForm.description = null;
      this.clearErrors();
    },
    setProcesamiento(procesamiento) {
      // console.log(procesamiento)
      this.parseDataProsecution(procesamiento);
      this.informarForm.id = procesamiento.id;
      this.informarForm.name = procesamiento.name;
      this.informarForm.description = procesamiento.description;
    },
    closeForm() {
      this.clearData();
      this.drawer = false;
    },
    handleCancel() {
      this.closeForm();
    },
    async handleStore() {
      if (!this.existErrors()) {
        await this.store(this.informarForm);
        this.closeForm();
      }
    },
    async handleUpdate() {
      this.informarForm.data = this.data;
      let newFormData = new FormData();
      newFormData.append("id", this.informarForm.id);
      newFormData.append("data", JSON.stringify(this.informarForm.data));
      newFormData.append("image", this.informarForm.image);

      // await this.update(this.informarForm);
      await this.store(newFormData);
      // if (!this.existErrors()) {
      //   this.closeForm();
      // }
    },
    existErrors() {
      let hasErrors = false;

      Object.keys(this.informarForm).forEach((f) => {
        if (this.$refs[f]) {
          if (!this.informarForm[f]) hasErrors = true;
          this.$refs[f].validate(true);
        }
      });

      return hasErrors;
    },
    clearErrors() {
      Object.keys(this.informarForm).forEach((f) => {
        if (this.$refs[f]) this.$refs[f].reset();
      });
    },
    changeCabecera(item) {
      this.data.map((dt) => {
        if (dt.specialized_id == item.specialized_id) {
          dt.select = true;
        } else {
          dt.select = false;
        }
      });
      // console.log("cabecera data: ", this.data)
    },

    extractLabels(value) {
      if (value) {
        let newValue = value.replace("<p", "<label");
        newValue = newValue.replace("</p>", "</label>");
        return newValue;
      }
    },

    parseDataProsecution(item) {
      const newData = [];
      item.detail.map((dt, index1) => {
        const detalle = [];
        if (dt.index == -1 && dt.service_id) {
          let countCkeck = 0;
          // let saveIdInit = dt.id;
          // let saveIdFin =
          //   item.detail.find(
          //     (dtAux) => dtAux.index == -1 && dtAux.id > saveIdInit
          //   )?.id || null;

          item.detail.map((dtAux, index2) => {
            if (dt.service_id == dtAux.service_id && dtAux.index != -1) {
              if (dtAux.prosecution_detail_id) {
                if (dt.id == dtAux.prosecution_detail_id) {
                  if (dtAux.check) countCkeck = countCkeck + 1;
                  detalle.push({
                    ...dtAux,
                    rank: this.extractLabels(dtAux.rank),
                  });
                }
              } else {
                if (dtAux.check) countCkeck = countCkeck + 1;
                detalle.push({
                  ...dtAux,
                  rank: this.extractLabels(dtAux.rank),
                });
              }
            }
          });

          if (dt.iscompound == "on ") {
            // validar check para analisis compuesto
            if (countCkeck == 0) dt.check = false;
            else dt.check = true;
          }

          newData.push({
            ...dt,
            select: true,
            detalle,
            rank: this.extractLabels(dt.rank),
          });
        }
      });

      console.log("data cabecera - detalle", newData);

      // ! ordenar el detalle segun el index
      newData.map((dta) => {
        dta.selected = true;
        dta.detalle.sort((x, y) => {
          let firstDate = new Date(x.index);
          let SecondDate = new Date(y.index);

          if (firstDate < SecondDate) return -1;
          if (firstDate > SecondDate) return 1;
          return 0;
        });
      });

      // console.log("data ordenado con su detalle", newData)

      // ! iteracion para agrupar las especialidades
      const newCabeceraDetalle = [];
      const detalleAux = [...newData];
      let firstData = true;

      detalleAux.map((dtaux) => {
        let band = true;
        newCabeceraDetalle.map((ncd) => {
          if (dtaux.specialized_id == ncd.specialized_id) {
            band = false;
          }
        });
        if (band) {
          const dataParaFiltrar = newData.filter(
            (ndt) => dtaux.specialized_id == ndt.specialized_id
          );
          if (firstData) {
            dtaux.select = true;
            firstData = false;
          } else {
            dtaux.select = false;
          }
          newCabeceraDetalle.push({
            specialized_name: dtaux.specialized_name,
            specialized_id: dtaux.specialized_id,
            select: dtaux.select,
            detalle: dataParaFiltrar,
          });
        }
      });

      this.data = newCabeceraDetalle;
      // console.log("===>> ", newCabeceraDetalle);
    },
    async changeGeneratePdf() {
      // console.log(this.informarForm.id);
      await this.generatePdf({
        id: this.informarForm.id,
        office_id: this.office_id,
      });

      // const content = await InformarTools.printInformar({});

      // html2pdf()
      //   .set({
      //     margin: 0,
      //     filename: "documento.pdf",
      //     image: {
      //       type: "jpeg",
      //       quality: 0.98,
      //     },
      //     html2canvas: {
      //       scale: 3, // A mayor escala, mejores gráficos, pero más peso
      //       letterRendering: true,
      //     },
      //     jsPDF: {
      //       unit: "in",
      //       format: "a4",
      //       orientation: "portrait", // landscape o portrait
      //     },
      //   })
      //   .from(content)
      //   .save();

      // this.genetePdf(content);
      // this.printInformar(content);
    },
    // genetePdf(content) {
    //   const doc = new jsPDF("p", "pt", "a4");
    //   console.log(content);
    //   doc.html(content);
    //   doc.save("a4.pdf");
    // },
    // printInformar(content) {
    //   $("<iframe>", { name: "voucheriframe", class: "printFrame" })
    //     .appendTo("html")
    //     .contents()
    //     .find("body")
    //     .append(content);

    //   window.frames["voucheriframe"].focus();

    //   setTimeout(() => {
    //     window.frames["voucheriframe"].print();
    //   }, 500);

    //   setTimeout(() => {
    //     $(".printFrame").remove();
    //   }, 1000);
    // },

    handleKeyUpResultado(event, item, subItem) {
      const value = event.target.value.trim().toLowerCase();
      let complementaryResult = false;
      if (value == "positivo") complementaryResult = true;

      this.data.map((dt) => {
        dt.detalle.map((dtItem) => {
          if (dtItem.id == subItem.id) {
            dtItem.complementaryResult = complementaryResult;
            if (!complementaryResult) dtItem.complementaryResultInput = null;
          }
        });
      });
    },

    handleKeyUpResultadoCompuesto(event, item, subItem, subSubItem) {
      const value = event.target.value.trim().toLowerCase();
      let complementaryResult = false;
      if (value == "positivo") complementaryResult = true;

      this.data.map((dt) => {
        dt.detalle.map((dtItem) => {
          if (dtItem.id == subItem.id) {
            dtItem.detalle.map((dtSubItem) => {
              if (dtSubItem.id == subSubItem.id) {
                dtSubItem.complementaryResult = complementaryResult;
                if (!complementaryResult)
                  dtSubItem.complementaryResultInput = null;
              }
            });
          }
        });
      });
    },

    changeCabeceraAnalisisCompuesta(itemDetalle) {
      const band = itemDetalle.check;
      this.data.map((dtF) => {
        dtF.detalle.map((dtS) => {
          if (dtS.id == itemDetalle.id) {
            dtS.detalle.map((dtT) => {
              dtT.check = band;
            });
          }
        });
      });
    },
    changeCabeceraDetailAnalisisCompuesta(itemDetalle, itemDetalleDetalle) {
      const checkDetail = itemDetalleDetalle.check;

      this.data.map((dtF) => {
        dtF.detalle.map((dtS) => {
          if (dtS.id == itemDetalle.id) {
            let count = 0;
            dtS.detalle.map((dtT) => {
              if (dtT.id == itemDetalleDetalle.id) dtT.check = checkDetail;

              if (dtT.check) count = count + 1;
            });
            if (count == 0) dtS.check = false;
            else dtS.check = true;
          }
        });
      });
    },
  },
};
</script>

<style scoped>
.btn {
  display: flex;
  justify-content: center;
  border-bottom: 2px solid #aaaaaa;
  padding-bottom: 5px 20px;
  font-weight: 700;
  font-size: 1.1rem;
  color: #aaaaaa;
}
.btn-active {
  color: black;
  border-color: #5045e6;
}
.btn:hover {
  background-color: #eeeeee;
}

.div-table-editor {
  padding-left: 1.6rem;
  padding-right: 1rem;
  padding-bottom: 1rem;
  height: 17rem;
}

.table-editor {
  height: 100%;
  width: 100%;
}

.btn-analisis {
  border-radius: 23px;
  padding: 0.5rem 2rem;
  background-color: #eeeeee;
  color: #aaaaaa;
  font-weight: 600;
}
.btn-analisis-active {
  color: #5045e6;
}

.line {
  height: 2px;
  width: 100%;
  background-color: #dddddd;
  margin-top: 17px;
}

.div-unidad {
  background-color: #dddddd;
  height: 25px;
  padding: 0 18px;
  border-radius: 10px;
  margin-right: 5px;
}

.btn-reactivo:hover {
  background-color: #c0bcff;
}
.btn-analisis-active:hover {
  background-color: #c0bcff;
}

.drop-zone {
  background-color: #eee;
  margin-bottom: 10px;
  padding: 10px;
}
.drag-el {
  background-color: #fff;
  margin-bottom: 10px;
  padding: 5px;
}
.v-messages {
  display: none !important;
}

.ql-align-right {
  margin-bottom: 0px !important;
}

.ql-toolbar .ql-snow + .ql-container .ql-snow {
  min-height: 130px !important;
}
.ql-container .ql-snow {
  min-height: 130px !important;
}

.ql-container .ql-snow {
  min-height: 130px !important;
}

#editor1 .ql-editor .ql-blank {
  min-height: 130px !important;
}

#editor2 .ql-editor .ql-blank {
  min-height: 130px !important;
}

#editor3 .ql-editor .ql-blank {
  min-height: 130px !important;
}

.ql-editor .ql-blank {
  min-height: 130px !important;
  height: 70px !important;
}

.ql-editor {
  height: 70px !important;
  min-height: 130px !important;
}

#editor1 .ql-editor {
  min-height: 130px !important;
  height: 70px !important;
}

#editor2 {
  min-height: 130px !important;
  height: 70px !important;
}

#editor3 {
  min-height: 130px !important;
  height: 70px !important;
}

.quillWrapper {
  min-height: 130px !important;
  height: 70px !important;
}
</style>
